<template>
  <div class="keywords-label push-down">
    {{ editName }}
  </div>
  <DataInput v-if="selectedUploadedFileData !== undefined"
      v-for="(d, index) in getDataFields"
      :key="index"
      :data="d"
      :val="selectedUploadedFileData[d.value]"
  />
</template>

<script>
import DataInput from '@/views/DataInput';
import { useModalStore } from '@/store/ModalStore';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia/dist/pinia';
import DateDisplay from './date/DateDisplay.vue';

export default {
  name: 'DataBlock',
  components: { DataInput, DateDisplay },
  props: [
      'editName',
      'type'
  ],
  computed: {
    ...mapStores(useRMTStore, useModalStore),
    selectedUploadedFileData () {
      const RMTStore = useRMTStore();
      return RMTStore.getSelectedUploadedFileData;
    },
    selectedResources () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedResources;
    },
    selectedUploads () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedUploads;
    },
    searchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
    getDataFields () {
      const RMTStore = useRMTStore();
      return (this.$props.type === 'resource') ? RMTStore.getDefaultData : RMTStore.collectionData;
    },
    getPanelIsHidden () {
      const RMTStore = useRMTStore();
      return RMTStore.panelIsHidden;
    }
  },
  methods: {
    handleDateClick () {
      this.modalStore.toggleModal('calendar');
    },
    handleExitMode () {
      this.RMTStore.createdCollectionId = [];
      this.RMTStore.createdCollectionItems = [];
      this.RMTStore.editCollectionItems = [];
      this.RMTStore.editCollectionId = [];
      this.RMTStore.setCancelMode(0);
      this.RMTStore.clearSelectedCollections();
      this.RMTStore.inCreateCollectionMode = false;
      this.RMTStore.isAddResource = false;
    }
  }
};
</script>

<style scoped>
.icon-size-del {
  width: 14px;
}

.circle {
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 30px;
  background-color: lightgrey;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-delete {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.push-down {
  margin-bottom: 12px;
}
</style>